import React from 'react';
import { MODE_AI } from '../HOME/const';

const baseKey = props => {
  let { mode, skill, size, clues } = props;

  mode = `${mode}-${mode === MODE_AI ? skill : clues}`;
  mode = mode.replace('MODE ', '');

  return `PT • ${mode} • ${size} • `;
};

export const boardKey = props => `${baseKey(props)}BOARD`;

export const statsKey = props => `${baseKey(props)}STATS`;

export const renderTitle = (text, classes) => {
  return (
    <div className={`${classes}`} style={{ display: 'grid' }}>
      <div style={{ gridArea: '1/1', color: 'black', transform: 'translate(0.05em, 0.05em)' }}>{text}</div>
      <div className="pt-title-gradient" style={{ gridArea: '1/1' }}>
        {text}
      </div>
    </div>
  );
};

export const sameTile = (tile1, tile2) => tile1 && tile2 && tile1.home.row === tile2.home.row && tile1.home.col === tile2.home.col;
